import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pubg',
  templateUrl: './pubg.component.html',
  styleUrls: ['./pubg.component.scss']
})
export class PubgComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
